import React from 'react';

export const SuitecaseSvg: React.FunctionComponent = () => (
  <svg viewBox="0 0 16 16" width="16" height="16" className="design-system-svg design-system-svg-size-small" fill="none">
    <path d="M4 14.5H12V3.78571C12 3.07589 11.3281 2.5 10.5 2.5H5.5C4.67188 2.5 4 3.07589 4 3.78571V14.5ZM6 4.21429H10V5.07143H6V4.21429ZM16 6.35714V13.2143C16 13.9241 15.3281 14.5 14.5 14.5H13V5.07143H14.5C15.3281 5.07143 16 5.64732 16 6.35714ZM3 14.5H1.5C0.671875 14.5 0 13.9241 0 13.2143V6.35714C0 5.64732 0.671875 5.07143 1.5 5.07143H3V14.5Z" fill="#000000"></path>
  </svg>
);
